import { Rule, Variant } from 'ctp-toll-domain';
import { initNavigationData } from '@/utils/store/tollDomains/tollDomainsNavigation';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import { TollDomainState } from './types/index';

export { namespace } from './types/index';

export const state: TollDomainState = {
  tollDomainsState: {
    loading: {
      domains: false
    },
    error: {
      domains: false
    },
    fetched: {
      domains: true
    }
  },
  domainInfo: {
    id: 0,
    variantId: 0,
    masterName: '',
    masterId: 0,
    countryCode: '',
    tspCode: '',
    providerID: 0,
    name: '',
    rules: [],
    type: NaN,
    startTs: 0
  },
  domains: [],
  navigation: initNavigationData,
  total: 0,
  errorMessage: '',
  userSelection: {
    domains: [],
    actions: {
      delete: {
        label: 'map.tolldomains.actions.delete',
        enabled: false
      }
    }
  },
  rule: {} as Rule,
  datInstances: [],
  variants: [] as Variant[]
};

const namespaced = true;

export const module = {
  namespaced,
  state,
  actions,
  getters,
  mutations
};
